import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import CourseModules from "../../common/CourseModules";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import AuthService from "../../services/auth.service";
import CourseService from "../../services/course.service";
import CartService from "../../services/cart.service";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Cart.css";
import { Modal } from "react-bootstrap";
import CourseImg from "../../assets/images/course-placeholder.png";

const CatalogCourseOverview = ({ fetchCartCourseData }) => {
  const location = useLocation();
  const { cid, enroll, price } = location.state;
  const [show, setShow] = useState(false);
  const [country, setCountry] = useState("");

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = (e, link) => {
    e.preventDefault();
    setShow(true);
  };

  const [currentCourse, setCurrentCourse] = useState({
    coursename: "",
    courseimg: "",
    coursedescription: "",
    demovideo: "",
  });
  const getCurrentCourse = (user, cid) => {
    CourseService.getCourseById(user, cid)
      .then((resp) => {
        setCurrentCourse({
          coursename: resp.data.course_info[0].name,
          courseimg: resp.data.course_info[0].course_image,
          coursedescription: resp.data.course_info[0].description,
          demovideo: resp.data.course_info[0].demoVideo,
        });
      })
      .catch((e) => console.log(e));
  };

  const addCoursesToCart = () => {
    const user = AuthService.getCurrentUser();
    const data = {
      usp: user.user,
      courid: cid,
    };
    CartService.addCourseToCart(data)
      .then((response) => {
        if (response.data === true) {
          toast.success("Added to cart!", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          fetchCartCourseData(user.user);
        } else {
          toast.warn("This course is already is cart!", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          // fetchCartCourseData(user.user);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    getCurrentCourse(user.user, cid);
    setCountry(user.country);
    console.log(user);
  }, []);

  const buyCourse = async (cid, price) => {
    const user = AuthService.getCurrentUser();
    const numericPrice = parseFloat(price);

    if (isNaN(numericPrice)) {
      console.error("Invalid price format");
      return;
    }

    const coursePrice = numericPrice.toFixed(2);

    const data = {
      amt: coursePrice,
      csid: cid,
      usid: user.user,
    };

    CartService.buyCartCourse(data)
      .then((response) => {
        const resData = response.data;
        const plink = resData.split(" ");
        const uplink = plink[26].replace('}\n}\n{"plink":"', "");
        const flink = uplink.replace("}", "");
        const nflink = flink.replace('"', "");
        window.open(`${nflink}`, "_blank");
      })
      .catch((e) => console.log(e));
  };

  return (
    <div className="row">
      <ToastContainer />
      <div className="row">
        <div className="col-xl-3 col-lg-3" style={{ paddingRight: 0 }}>
          <div className="outer-box">
            <div className="action-flex mb-4">
              <Link to="/Catalog">
                <div className="action-item">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 19.379 19.382"
                    >
                      <g
                        id="left-arrow-in-circular-button-black-symbol"
                        transform="translate(-0.6 511.567)"
                      >
                        <path
                          id="Path_13057"
                          data-name="Path 13057"
                          d="M9.381-511.546A9.911,9.911,0,0,0,4.162-509.4a11.83,11.83,0,0,0-1.457,1.468,10.165,10.165,0,0,0-1.878,3.88A8.145,8.145,0,0,0,.6-501.873a8.145,8.145,0,0,0,.228,2.181,10.088,10.088,0,0,0,1.931,3.945,11.828,11.828,0,0,0,1.468,1.457,10.164,10.164,0,0,0,3.88,1.878,8.146,8.146,0,0,0,2.181.228,8.146,8.146,0,0,0,2.181-.228,10.541,10.541,0,0,0,3.141-1.339A9.712,9.712,0,0,0,19-497.606a9.626,9.626,0,0,0,.914-2.94,12.941,12.941,0,0,0,0-2.655,9.626,9.626,0,0,0-.914-2.94,9.19,9.19,0,0,0-1.889-2.625,9.01,9.01,0,0,0-2.553-1.813,9.581,9.581,0,0,0-2.9-.91A14.607,14.607,0,0,0,9.381-511.546Zm1.1,5.618a.61.61,0,0,1,.25.766c-.03.068-.622.69-1.328,1.392L8.126-502.5l3.315.019c3.277.019,3.319.019,3.421.1a.536.536,0,0,1,.262.508.536.536,0,0,1-.262.508c-.1.08-.144.08-3.421.1l-3.315.019L9.4-499.977c.706.7,1.3,1.324,1.328,1.392a.607.607,0,0,1-.77.808c-.14-.053-3.683-3.588-3.751-3.744a1.386,1.386,0,0,1-.015-.683c.053-.133,3.581-3.679,3.736-3.751A.637.637,0,0,1,10.477-505.928Z"
                          transform="translate(0 0)"
                        />
                      </g>
                    </svg>
                  </span>
                  <span>Back</span>
                </div>
              </Link>
            </div>
            <div className="course-info cat-course-info">
              <div className="course-name">
                <span>{currentCourse.coursename}</span>
              </div>
              <div className="course-modules">
                <label htmlFor="">Course Modules :-</label>
                <CourseModules cid={cid} />
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-9 col-lg-9" style={{ paddingRight: 0 }}>
          <div className="row mb-3">
            <div className="col-xl-12 col-lg-12">
              <div className="outer-box">
                <div className="course-overview">
                  <div className="course-img">
                    {enroll === null || enroll === undefined ? (
                      <>
                        {currentCourse.courseimg !== "" ? (
                          <>
                            <div className="course-preview">
                              <div className="overlay"></div>
                              <img
                                src={
                                  "https://elearning.gaa.aero/cit/" +
                                  currentCourse.courseimg
                                }
                                alt=""
                              />
                              {currentCourse.demovideo !== "" ? (
                                <>
                                  <button onClick={(e) => handleShow(e)}>
                                    <svg
                                      version="1.1"
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="36"
                                      height="36"
                                      viewBox="0 0 512 512"
                                    >
                                      <path
                                        d="M0 0 C1.79486878 1.00295579 3.58866732 2.00865339 5.35791016 3.05615234 C7.57012898 4.36549028 9.80394675 5.63159777 12.04296875 6.89453125 C15.58108835 8.89665929 19.10811891 10.91677274 22.62890625 12.94921875 C28.60051013 16.38990702 34.60881007 19.76302531 40.625 23.125 C41.66938232 23.70894531 42.71376465 24.29289062 43.78979492 24.89453125 C45.91861821 26.08444121 48.04760654 27.27405593 50.17675781 28.46337891 C64.37385548 36.39424614 78.55960567 44.34430638 92.71142578 52.35571289 C99.75475964 56.34058246 106.81206584 60.29998867 113.875 64.25 C122.8343421 69.26059503 131.77781974 74.29829051 140.7109375 79.35546875 C147.75446347 83.34036769 154.81190717 87.29989994 161.875 91.25 C170.8343421 96.26059503 179.77781974 101.29829051 188.7109375 106.35546875 C195.75446347 110.34036769 202.81190717 114.29989994 209.875 118.25 C218.8343421 123.26059503 227.77781974 128.29829051 236.7109375 133.35546875 C243.75446347 137.34036769 250.81190717 141.29989994 257.875 145.25 C266.8343421 150.26059503 275.77781974 155.29829051 284.7109375 160.35546875 C291.75446347 164.34036769 298.81190717 168.29989994 305.875 172.25 C314.8343421 177.26059503 323.77781974 182.29829051 332.7109375 187.35546875 C339.75446401 191.34036799 346.81196193 195.29980134 353.875 199.25 C363.85386535 204.83242003 373.82317942 210.43105099 383.765625 216.078125 C387.57450419 218.23977722 391.39853649 220.37095831 395.234375 222.484375 C397.11458597 223.53124527 398.9947944 224.57812009 400.875 225.625 C401.72932617 226.0885791 402.58365234 226.5521582 403.46386719 227.02978516 C411.60075701 231.5895017 417.58432021 236.68662623 420.71484375 245.64453125 C422.54900911 252.88351525 421.57636548 258.83577095 418.93359375 265.73046875 C414.09752691 273.54817079 406.9280858 277.57001928 399 281.8125 C396.75504189 283.04136265 394.51025501 284.27053816 392.265625 285.5 C390.54956055 286.43199219 390.54956055 286.43199219 388.79882812 287.3828125 C383.42378887 290.3140946 378.08780676 293.31412307 372.75 296.3125 C370.6640765 297.48049375 368.57813907 298.64846262 366.4921875 299.81640625 C359.66426153 303.64509932 352.85084509 307.49925691 346.03857422 311.35571289 C337.94347336 315.93563509 329.82855836 320.47967662 321.7109375 325.01953125 C314.75530205 328.91158037 307.81114796 332.82333772 300.875 336.75 C291.83559691 341.86734803 282.77685704 346.9493318 273.7109375 352.01953125 C266.75530205 355.91158037 259.81114796 359.82333772 252.875 363.75 C243.83559691 368.86734803 234.77685704 373.9493318 225.7109375 379.01953125 C218.75530205 382.91158037 211.81114796 386.82333772 204.875 390.75 C195.83559691 395.86734803 186.77685704 400.9493318 177.7109375 406.01953125 C170.75530205 409.91158037 163.81114796 413.82333772 156.875 417.75 C147.83559691 422.86734803 138.77685704 427.9493318 129.7109375 433.01953125 C122.75530205 436.91158037 115.81114796 440.82333772 108.875 444.75 C99.83559691 449.86734803 90.77685704 454.9493318 81.7109375 460.01953125 C74.75530205 463.91158037 67.81114796 467.82333772 60.875 471.75 C51.84816942 476.86023054 42.80294095 481.93679618 33.74829102 486.99755859 C28.47877038 489.94472886 23.21578969 492.9026542 17.96484375 495.8828125 C16.93101563 496.46933594 15.8971875 497.05585938 14.83203125 497.66015625 C12.8817896 498.76773204 10.93250097 499.87698839 8.984375 500.98828125 C6.45605668 502.42407078 3.91837508 503.84109311 1.375 505.25 C0.66021484 505.65694092 -0.05457031 506.06388184 -0.79101562 506.4831543 C-8.26013153 510.53552781 -16.44738795 510.78360462 -24.60546875 508.3671875 C-31.68577319 505.13231315 -36.02616202 500.72383206 -39.26134682 493.69467163 C-41.70845022 485.91371717 -41.03719912 477.45752965 -41.00595093 469.38525391 C-41.00940935 467.44524179 -41.01417515 465.50523165 -41.02013266 463.5652256 C-41.03264693 458.24414194 -41.02647025 452.92321987 -41.01717401 447.60213566 C-41.01038565 441.85972567 -41.0208637 436.11734344 -41.02911377 430.37493896 C-41.04245554 419.12947782 -41.03957136 407.88407673 -41.03087585 396.63861322 C-41.02410147 387.49940657 -41.02318152 378.36021675 -41.0264473 369.2210083 C-41.026907 367.92040643 -41.02736669 366.61980457 -41.02784032 365.27979052 C-41.0287995 362.6376659 -41.02977214 359.99554129 -41.0307581 357.35341668 C-41.0390694 333.28294171 -41.03044938 309.21249832 -41.01473031 285.14202848 C-41.00049379 263.17474624 -41.00176769 241.20751616 -41.01611328 219.24023438 C-41.03218179 194.55223189 -41.03848931 169.86425945 -41.02927649 145.17625237 C-41.02832084 142.54383215 -41.02737773 139.91141193 -41.0264473 137.2789917 C-41.02598447 135.98378117 -41.02552164 134.68857064 -41.02504479 133.35411131 C-41.02245422 124.22558938 -41.02682736 115.09708596 -41.03388596 105.96856689 C-41.04229858 94.84438492 -41.04002575 83.72026645 -41.02404372 72.59609175 C-41.01615788 66.92008182 -41.01307486 61.24417779 -41.02299118 55.56816864 C-41.03193193 50.37199509 -41.02701526 45.1760256 -41.01105852 39.97987056 C-41.00770812 38.10045153 -41.0094106 36.22101526 -41.01668589 34.34160733 C-41.09719885 11.81435562 -41.09719885 11.81435562 -33.4609375 3.82421875 C-23.78529794 -4.47212751 -11.42198317 -5.53464267 0 0 Z "
                                        fill="#000000"
                                        transform="translate(65.625,2.75)"
                                      />
                                    </svg>
                                  </button>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <img src={CourseImg} width="500px" alt="" />
                          </>
                        )}
                      </>
                    ) : (
                      <>
                        {currentCourse.courseimg !== "" ? (
                          <>
                            <img
                              src={
                                "https://elearning.gaa.aero/cit/" +
                                currentCourse.courseimg
                              }
                              alt=""
                            />
                          </>
                        ) : (
                          <>
                            <img src={CourseImg} width="500px" alt="" />
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-xl-12">
              <div className="outer-box">
                <div className="cflex">
                  <div className="heading">
                    <h1>Course Overview</h1>
                  </div>
                </div>

                <div
                  dangerouslySetInnerHTML={{
                    __html: currentCourse.coursedescription,
                  }}
                  className="course-overview"
                />

                <div className="cart-btn-details">
                  {/* {country === "IN" ? (
                    <>
                      <div className="buy-btn">
                        <button onClick={() => buyCourse(cid, price)}>
                          Buy Now
                        </button>
                      </div>
                      <div className="add-cart-btn">
                        <button onClick={addCoursesToCart}>Add to cart</button>
                      </div>
                    </>
                  ) : (
                    <></>
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Body>
          <div className="mb-3">
            <span>Course Preview</span>
            <h4>{currentCourse.coursename}</h4>
          </div>

          <video controls width="100%" controlsList="nodownload">
            <source
              src={"https://elearning.gaa.aero/cit/" + currentCourse.demovideo}
              type="video/webm"
            />
            <source
              src={"https://elearning.gaa.aero/cit/" + currentCourse.demovideo}
              type="video/mp4"
            />
            Sorry, your browser doesn't support videos.
          </video>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CatalogCourseOverview;
